import { FC } from 'react';

import { IField, IForm } from '@.hooks';
import { Select } from '@.ui';
import { AccessObjectTypeEnum } from '@/Services/api/methods';
import { DictionaryResponseKnown } from '@/Types/api/Dictionaries';

import { AccessObjectNumberMap } from '../AccessObjectNumberMap';
import { UsersData } from '../types';
import S from './styles.module.scss';

type AccessObjectSelectProps = {
    field: IField<UsersData>;
    form: IForm<UsersData>;
    dictionaries?: Partial<DictionaryResponseKnown>;
    isFormDisabled?: boolean;
};

export const AccessObjectSelect: FC<AccessObjectSelectProps> = ({ field, form, dictionaries, isFormDisabled }) => {
    const accessObjectTypeValue = form.state.access_object_type?.value;

    const selectedCompanyId = form.state.company_id?.value;
    const selectedStoreGroupId = form.state.access_object_store_group_id?.value;

    const storeGroups = dictionaries?.store_groups?.filter((storeGroup) => storeGroup.company_id === selectedCompanyId);
    const stores =
        accessObjectTypeValue === AccessObjectTypeEnum.STORE && selectedStoreGroupId
            ? dictionaries?.stores?.filter((store) => store.store_group_id === selectedStoreGroupId)
            : [];

    const isStoresExists = stores && stores.length > 0;

    const isShowStoreGroupEmptyStoresError = accessObjectTypeValue === AccessObjectTypeEnum.STORE && !isStoresExists;

    const isShowStoresByStoreGroup = accessObjectTypeValue === AccessObjectTypeEnum.STORE && selectedStoreGroupId && isStoresExists;

    const isShowStoreGroupSelect = accessObjectTypeValue === AccessObjectTypeEnum.STORE_GROUP || accessObjectTypeValue === AccessObjectTypeEnum.STORE;

    const onAccessObjectTypeChange = (_?: number, value?: AccessObjectTypeEnum | unknown) => {
        form.set.fieldValue('access_object_type', value);
    };

    return (
        <div className={S.wrapper}>
            <Select
                {...field('access_object_type').register<number>()}
                onChange={onAccessObjectTypeChange}
                value={accessObjectTypeValue ? AccessObjectNumberMap[accessObjectTypeValue] : undefined}
                label="Access Type"
                theme="white"
                disabled={isFormDisabled}
            >
                <Select.Option id={AccessObjectNumberMap[AccessObjectTypeEnum.STORE_GROUP]} value={AccessObjectTypeEnum.STORE_GROUP}>
                    By store group
                </Select.Option>
                <Select.Option id={AccessObjectNumberMap[AccessObjectTypeEnum.STORE]} value={AccessObjectTypeEnum.STORE}>
                    By store
                </Select.Option>
            </Select>
            {isShowStoreGroupSelect && (
                <Select
                    {...field('access_object_store_group_id').register<number>()}
                    label="Store group"
                    theme="white"
                    required
                    placeholder="Select store groups"
                    errors={isShowStoreGroupEmptyStoresError ? ['This store group has no stores'] : undefined}
                    disabled={isFormDisabled}
                >
                    {storeGroups?.map((storeGroup) => (
                        <Select.Option key={storeGroup.id} id={storeGroup.id}>
                            {storeGroup.name}
                        </Select.Option>
                    ))}
                </Select>
            )}

            {isShowStoresByStoreGroup && (
                <Select
                    {...field('access_object_store_id').register<number>()}
                    label="Store"
                    placeholder="Select store"
                    theme="white"
                    required
                    disabled={isFormDisabled}
                >
                    {stores?.map((store) => (
                        <Select.Option key={store.id} id={store.id}>
                            {store.name}
                        </Select.Option>
                    ))}
                </Select>
            )}
        </div>
    );
};
